export default class Router {
  constructor(routes, location) {
    const pathname = location.pathname;

    // Lowercase the keys and sort them
    const params = [...new URLSearchParams(location.search).entries()].map(([k, v]) => [k.toLowerCase(), v]).sort();

    // Rewrite the history to remove the location.search from the address bar
    history.replaceState({}, "", pathname);

    // Find the route that matches the pathname and query parameters
    let route = routes.find((routePath) => {
      if (routePath.path !== pathname) {
        // Exit early if the paths don't match
        return false;
      }

      const routeKeys = routePath.queryParamKeys.map((k) => k.toLowerCase()).sort();
      if (routeKeys.length !== params.length) {
        // Exit early if the number of keys don't match
        return false;
      }

      // Return true if all keys match
      return params.every((k, i) => k[0] === routeKeys[i]);
    });

    // Set a default route if none was found
    if (!route) {
      route = { title: "404", component: "NotFound", queryParamKeys: [] };
    }

    if (route.handler) {
      // Return the query params. We only deal with GETs so no need to parse body.
      route.handler({ query: Object.fromEntries(params) });
    }
  }
}
